




















import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

import { MessageEditorComponentSettings, MessageEditorWithMediaTab } from '../../../types'

@Component
export default class MessageBodyTabs extends Vue {
  @VModel() currentTab!: MessageEditorWithMediaTab

  @Prop({ type: Array, default: () => [] }) availableTabs!: MessageEditorComponentSettings['availableTabs']

  tabsIcons = {
    [MessageEditorWithMediaTab.EditorTab]: 'mode_edit',
    [MessageEditorWithMediaTab.TextareaTab]: 'code',
    [MessageEditorWithMediaTab.SettingsTab]: 'settings',
  }

  get tabs() {
    return [
      MessageEditorWithMediaTab.EditorTab,
      MessageEditorWithMediaTab.TextareaTab,
      MessageEditorWithMediaTab.SettingsTab,
    ]
  }

  get visibleTabs() {
    return this.tabs.filter(t => (this.availableTabs ?? []).includes(t))
  }
}
